import { getOwaWorkload } from 'owa-workloads';
import OwaWorkload from 'owa-workloads/lib/store/schema/OwaWorkload';
import { GeneralOptions } from 'owa-options-general';
import { MailOptions } from 'owa-options-mail';
import { CalendarOptions } from 'owa-options-calendar';
import { PeopleOptions } from 'owa-options-people';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function getDefaultCategory(): string {
    switch (getOwaWorkload()) {
        case OwaWorkload.Mail:
        case OwaWorkload.MailMini:
            return MailOptions.key;
        case OwaWorkload.Calendar:
            return CalendarOptions.key;
        case OwaWorkload.People:
            return isFeatureEnabled('people-option-displayby')
                ? PeopleOptions.key
                : GeneralOptions.key;
        default:
            return GeneralOptions.key;
    }
}
